module.exports = __webpack_public_path__ + "static/media/info_square.4ebcc685.svg";